import React, { FC, ReactElement } from 'react'

import './StudentDashboardCustomTable.scss'

interface IStudentDashboardCustomTableProps {
  children: ReactElement
  id?: string
}

const StudentDashboardCustomTable: FC<IStudentDashboardCustomTableProps> = ({ children, id }) => {
  return (
    <div className="student-dashboard-custom-table--layout" id={id}>
      {children}
    </div>
  )
}

export default StudentDashboardCustomTable
